module.exports = __webpack_public_path__ + "img/login_tab01_02.5e9df22d.png";